module.exports = __webpack_public_path__ + "img/17842_S.57a3b438.png";